'use client';
import OvivaSpecial from '@/components/landingPage/OvivaSpecial';
import FeelgoodWeight from '@/components/landingPage/FeelgoodWeight';
import SuccessStories from '@/components/landingPage/SuccessStories';
import StickyCTAButton from '@/components/landingPage/StickyCTAButton';
import DoctorReview from '@/components/landingPage/DoctorReview';
import ProcessExplanation from '@/components/landingPage/ProcessExplanation';
import LandingPageLayout from '@/components/landingPage/LandingPageLayout';
import { BRAND_ACTIVE_EXPERIMENTS } from '@data/surveyConfigs';
import { ABTestProvider } from '@/components/ABTest';
import PartnerLogos from '@/components/landingPage/PartnerLogos';
import TopCallToActionTV from '@/components/landingPage/TopCallToActionTV';
import React from 'react';

export default function LandingPage() {
  return (
    <ABTestProvider configs={BRAND_ACTIVE_EXPERIMENTS}>
      <LandingPageLayout showHeaderButton>
        <PartnerLogos />
        <TopCallToActionTV
          bulletPoints={[
            'Ohne Kalorienzählen',
            'Mahlzeiten fotografieren und Ernährungstipps in der App erhalten',
            '100 % kostenlos für dich',
          ]}
        >
          <>
            <p className="font-serif text-[60px] 2xs-max:text-[40px] leading-[130%] tracking-[0.5px] !mb-0">
              Abnehmen?
            </p>
            <p className="font-serif text-[44px] 2xs-max:text-[30px] leading-[130%] tracking-[0.5px] !my-0">
              App nehmen!
            </p>
            <p className="text-[24px] 2xs-max:text-[18px] font-semibold tracking-[0.15px] !mt-6">
              Mit neuer Energie in den Sommer. Kostenlos abnehmen mit Oviva.
            </p>
          </>
        </TopCallToActionTV>
        <OvivaSpecial />
        <FeelgoodWeight />
        <SuccessStories />
        <ProcessExplanation />
        <DoctorReview />
        <StickyCTAButton />
      </LandingPageLayout>
    </ABTestProvider>
  );
}
